import React, { Component } from 'react';
import styled from 'styled-components';

const AppDivider = styled.div`
    width: 90%;
    // height: 1px;
    margin: 0 auto;
    background-color: #ddd;
`;

export default class Divider extends Component {
    render() {
        const { className } = this.props;
        return (
            <AppDivider className={className}></AppDivider>
        )
    }
}
